const devSubDomains: string[] = ['localhost', 'dev', 'develop', 'staging', 'pr-'];

export default devSubDomains;
